import merge from 'deepmerge';
import { forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

const toJsonPath = (path) => path.concat('.json');
const PATH_TEMPLATE_REGEX = /{([^}]+)}/gi;
const PATH_CLEAN_REGEX = /([^:]\/)\/+/gi;
const DEFAULT_PATH_TEMPLATE = '{baseTranslateUrl}/{moduleName}/{language}';
class NgxTranslateModuleLoader {
    /**
     * The ModuleTranslateLoader for 'ngx-translate/core'
     *
     * @description Fetch multiple translation files (http).
     *
     * @param http the HttpClient from 'angular/common'
     * @param options the configurable options for ModuleTranslateLoader
     *
     * @see https://github.com/larscom/ngx-translate-module-loader
     */
	private http;
	private options;
	private defaultOptions;
    constructor(http, options) {
        this.http = http;
        this.options = options;
        this.defaultOptions = Object.assign({ disableNamespace: false, lowercaseNamespace: false, deepMerge: true }, this.options);
    }
    getTranslation(language) {
        const { defaultOptions: options } = this;
        return this.mergeTranslations(this.getModuleTranslations(language, options), options);
    }
    mergeTranslations(moduleTranslations, { deepMerge, translateMerger }) {
        return forkJoin(moduleTranslations).pipe(map((translations) => {
            return translateMerger
                ? translateMerger(translations)
                : deepMerge
                    ? merge.all(translations)
                    : translations.reduce((acc, curr) => (Object.assign(Object.assign({}, acc), curr)), Object());
        }));
    }
    getModuleTranslations(language, options) {
        const { modules } = options;
        return modules.map((module) => {
            const { moduleName } = module;
            return moduleName
                ? this.fetchTranslationForModule(language, options, module)
                : this.fetchTranslation(language, options, module);
        });
    }
    fetchTranslation(language, { translateError, version }, { pathTemplate, baseTranslateUrl, translateMap }) {
        const pathOptions = { baseTranslateUrl, language };
        const template = pathTemplate || DEFAULT_PATH_TEMPLATE;
        const path = toJsonPath(template.replace(PATH_TEMPLATE_REGEX, (_, m1) => pathOptions[m1] || ''));
        const cleanedPath = path.replace(PATH_CLEAN_REGEX, '$1');
        const pathWithVersion = version ? `${cleanedPath}?v=${version}` : cleanedPath;
        return this.http.get(pathWithVersion).pipe(map((translation) => (translateMap ? translateMap(translation) : translation)), this.catchError(cleanedPath, translateError));
    }
    fetchTranslationForModule(language, { disableNamespace, lowercaseNamespace, translateError, version }, { pathTemplate, baseTranslateUrl, moduleName, namespace, translateMap }) {
        const pathOptions = { baseTranslateUrl, moduleName, language };
        const template = pathTemplate || DEFAULT_PATH_TEMPLATE;
        const path = toJsonPath(template.replace(PATH_TEMPLATE_REGEX, (_, m1) => pathOptions[m1] || ''));
        const cleanedPath = path.replace(PATH_CLEAN_REGEX, '$1');
        const namespaceKey = namespace
            ? namespace
            : moduleName; //change by ken
        const pathWithVersion = version ? `${cleanedPath}?v=${version}` : cleanedPath;
        return this.http.get(pathWithVersion).pipe(map((translation) => {
            return translateMap
                ? translateMap(translation)
                : disableNamespace
                    ? translation
                    : Object({ [namespaceKey]: translation });
        }), this.catchError(cleanedPath, translateError));
    }
    catchError(path, translateError) {
        return catchError((e) => {
            if (translateError) {
                translateError(e, path);
            }
            console.error('Unable to load translation file:', path);
            return of(Object());
        });
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTranslateModuleLoader };
//# sourceMappingURL=larscom-ngx-translate-module-loader.js.map
